import {AppStatus} from "../types/signatures";
import {SignatureTypes} from "../types/pdfSignatures";
import {LocaleCommonType} from "./index";
import {ENV} from "../utils/constants";

const it: LocaleCommonType = {
    locale: {
        en: "EN",
        it: "IT",
    },
    user: {
        profile: "Profilo utente",
        account: "Account",
        logout: "Disconnetti",
        login: "Accedi",
        buy: "Acquista",
        intDoc: "Integra/Documentazione",
        support: "Supporto",
        name: "Nome",
        email: "Email",
        modify: "Modifica",
        save: "Salva modifiche",
        apiKeys: {
            title: "Chiavi Api",
            create: "Crea Chiave Api",
            toStart: "Per iniziare crea le tue chiavi API.",
            help: "Qui puoi visualizzare il riepilogo delle chiavi API generate.<br/>Per questioni di sicurezza possono essere presenti massimo 2 chiavi API contemporaneamente. Se sono presenti 2 chiavi, per crearne una nuova è necessario eliminare una di quelle esistenti.",
            new: "Nuova chiave API",
            id: "Id Chiave",
            secret: "Secret Key",
            warning: "Attenzione! La Secret Key sarà visibile solo ora, copia le informazioni sugli appunti",
            error: "Per creare una nuova chiave API elimina una di quelle esistenti",
            delete: "Sei sicuro di voler eliminare questa chiave API?",
            notAllowed: "Non ci sono presenti acquisti, vai allo store",
        },
        documentation: "Documentazione",
        resetPasswordMessage: "Un'email è stata inviata al tuo indirizzo con le istruzioni per cambiare la password",
        resendEmail: "invia nuovamente",
        resendEmailMessage: "Un'email è stata inviata al tuo indirizzo con le istruzioni per la verifica dell'account. Dopo aver verificato il tuo account, ricarica questa pagina",
        confirmEmail: "Per proseguire verifica il tuo indirizzo e-mail cliccando sul link presente nella mail ricevuta all’indirizzo <b>%{email}</b>, dopodiché clicca sul pulsante sottostante.",
        verified: "Indirizzo email verificato",
        resendEmailLink: "Non trovi la mail di verifica? Invia nuovamente",
    },
    menu: {
        home: "Home",
        endpoints: {
            title: "Endpoint",
            pdf: "Document Simple Forensic",
            aes: "Document Advanced",
            pdfsimple: "Document Simple",
            html: "Webpage Forensic",
            data: "Data Forensic",
            timestamp: "Timestamp",
        },
        admin: {
            title: "Amministrazione",
            apiKeys: "Chiavi API",
            archCall: "Archetipi e callback",
            docs: "Documentazione API",
            validator: "Validatore",
        },
        dashboard: "Dashboard",
    },
    home: {
        payoff: "Firma elettronica delle interazioni su Internet",
        call: "Accedi o acquista crediti per procedere con l'utilizzo di Web Sign.",
        contactus: "Hai bisogno aiuto?",
        contactSubject: "Ho bisogno di aiuto con Web Sign",
        contactBody: "Salve,\nAvremmo bisogno di aiuto con Web Sign,\n",
    },
    generic: {
        ok: "OK",
        yes: "Sì",
        delete: "Elimina",
        cancel: "Annulla",
        no: "No",
        close: "Chiudi",
        or: "oppure",
        true: "Sì",
        false: "No",
        create: "Crea",
        emptyCollection: "Non hai ancora fatto niente",
        required: "Campo obbligatorio",
        badJson: "Json malformato",
        badUrl: "URL malformato",
    },
    callbacks: {
        title: "Callback",
        create: "Crea callback",
        svix: "Ispeziona le callback",
        table: {
            resourceType: "Tipo risorsa",
            endpoint: "Endpoint",
            onlyFinalStatuses: "Solo stati finali",
            events: "Eventi",
            Interaction: "Webpage/Data API",
            Signature: "Document API",
            USER_CONCLUDED: "L'utente ha concluso",
        }
    },
    archetypes: {
        title: "Archetipi",
        create: "Crea archetipo",
        table: {
            mandatoryTags: "Tag obbligatori",
            formTags: "Tag di form",
            name: "Nome",
            smsCustomMessage: "Messaggio per SMS",
            smsCustomMessageModeratedOn: "Data moderazione SMS",
            openCustomisations: "Personalizzazioni",
            signatureCustomisations: "Personalizzazioni delle firme",
        },
        errorDeleting: "Non si può cancellare l'archetipo perché è associato a una interazione",
        hintTag: "Puoi immettere più di uno separato da virgola",
    },
    input: {
        copy: "Copia",
        copied: "Copiato",
    },
    error: {
        page: "Errore",
        forbidden: "Accesso negato",
        notFound: "Pagina non trovata",
        notAuthenticated: "Utente non autenticato",
        delete: "Non è stato possibile cancellare",
    },
    interaction: {
        totalUsed: "Firme utilizzate totali",
        available: "Firme Rimanenti",
        overQuota: "Firme extra consumate",
        consumedDocuments: "Documenti extra conservati",
        tsTotalUsed: "Marcature utilizzate totali",
        tsAvailable: "Marcature Rimanenti",
        tsOverQuota: "Marcature extra consumate",
        empty: `Hai finito le chiamate API prepagate, da adesso in poi tutte le chiamate API fatte saranno fatturate separatamente. If you want to change your subscription go to the <a href="https://${ENV !== "prod" ? `${ENV}.` : ""}store.kopjra.com/web-trust" target="_blank"><b>Store</b></a>.`,
        html: "Webpage",
        htmlTitle: "Firme Forensi Webpage",
        data: "Data",
        dataTitle: "Firme Forensi Data",
        PDF: "Documenti",
        pdfTitle: "Firme Forensi Documenti",
        pdfSimpleTitle: "Firme Semplici Documenti",
        timestamp: "Marcatura Temporale",
        timestampTitle: "Marcature Temporali",
        noTimestamps: "Non è ancora presente alcun timestamp",
        dragFiles: "Trascina un file qui oppure clicca per selezionare un file",
        doTrustedTimestamp: "Marcatura Trusted",
        doTrustlessTimestamp: "Marcatura Trustless",
        aesTitle: "Firme Avanzate Documenti",

        noInteraction: "Non è ancora presente alcuna firma.",
        noKeys: "Per iniziare crea le tue chiavi API oppure accedi alla documentazione.",
        withKeys: "Per iniziare accedi alla documentazione.",
        table: {
            id: "Id",
            createdAt: "Data di creazione",
            oURL: "oUrl",
            currentStatus: "Stato",
            userLandedAt: "Arrivo utente",
            userTookoffAt: "Partenza utente",
            signerFullname: "Nome Firmatario",
            signatureType: "Tipo di firma",
            otpSms: "Otp sms",
            appStatus: {
                [AppStatus.ONGOING]: "In corso",
                [AppStatus.FAILED]: "Fallita",
                [AppStatus.CONCLUDED]: "Conclusa",
            },
            signatureTypes: {
                [SignatureTypes.GRAPHIC]: "Tratto grafico",
                [SignatureTypes.NONE]: "Senza tratto",
                [SignatureTypes.FULLNAME_DATE]: "Tratto auto dal Nome",
                [SignatureTypes.INITIALS_DATE]: "Tratto auto dalle iniziali",
            },
            trusted: "Trusted",
            timestampRequestedAt: "Data di Richiesta",
            download: "Scarica",
            downloadXML: "XML",
            downloadPDF: "PDF",
            details: "Dettagli",
            filter: {
                id: "ID",
                oUrl: "oURL",
                signerFullname: "Nome firmatario",
                signatureType: "Tipo di firma",
                otpSms: "Otp sms",
                currentStatus: "Stato",
                tagKey: "Tag Key",
                tagValue: "Tag Value",
                fileName: "Nome file",
                trusted: "Trusted",
            },
        },
    },
    kptable: {
        filters: "Filtri",
        apply: "Applica",
        show_columns: "Mostra colonne",
        pager: {
            first: "Primo",
            last: "Ultima",
        },
        actions: "Azioni",
        date: {
            short: "DD/MM/YYYY",
            long: "DD/MM/YYYY HH:mm",
        },
        confirm: {
            yes: "Sì",
            no: "No",
        },
        show: "Mostra",
        globalSelectionWarn: "Questa selezione si applica solo per i %{count} elementi visibili",
    },
};
export default it;
